//@flow
import type { KratosFormData$Type,Form$PropertyInfo,Form$SignatureInfo,Form$ExeceptionFormInfo } from './flowTypes'
import type { ECForm$Type,ECForm$BillingContact,ECForm$ExemptionRequest } from './ecFormFlowTypes'
import type { RRForm$Type,RRForm$EmergencyContactInfo,
    RRForm$RegistrantInfo,RRUForm$Type,RRUForm$FormPageInfo } from './rrFormFlowTypes'

export const EC_FORM_TYPE = "ec"
export const RR_FORM_TYPE = "rr"
export const RRB_FORM_TYPE = "rrb"
export const RRU_FORM_TYPE = "rru"
export const EXC_FORM_TYPE = "exc"

export const getFormTypeData=(inputFormData: any)=>{
    let formData: KratosFormData$Type = {
        apn: inputFormData.apn
    }

    if (inputFormData.formType == EC_FORM_TYPE){
        formData.ec = getECFormData(inputFormData)
    }else if (inputFormData.formType == RR_FORM_TYPE) {
        formData.rr = getRRFormData(inputFormData)
    }else if (inputFormData.formType == RRB_FORM_TYPE){
        formData.rrb = getRRBFormData(inputFormData)   
    }else if (inputFormData.formType == RRU_FORM_TYPE) {
        formData.rru = getRRUFormData(inputFormData)
    }else if (inputFormData.formType == EXC_FORM_TYPE) {
        formData.exc = getExceptionFormData(inputFormData)
    }

    return formData
}

export const getFormStringValue=(data:any,field:string)=>{
    const value = data[field]?data[field]:''
    return value
}

export const getFormBoolValue=(data:any,field:string)=>{
    const value = data[field]?data[field]:false
    return value
}

const getExceptionFormData=(inputFormData: any) => {
    const propertyInfo: Form$PropertyInfo = {
        apn: inputFormData["apn"]
    }
    const excFormData: Form$ExeceptionFormInfo = {
        correspondenceType: getFormStringValue(inputFormData,"correspondenceType"),
        propertyInfo: propertyInfo
    }
    return excFormData
}

const getECFormData=(inputFormData: any)=>{
    const billingContact:ECForm$BillingContact = {
        noChanges: getFormStringValue(inputFormData,"noChanges"),
        firstName: getFormStringValue(inputFormData,"firstName"),
        isFirstNameNotReadable: getFormBoolValue(inputFormData,"isFirstNameNotReadable"),
        lastName: getFormStringValue(inputFormData,"lastName"),
        isLastNameNotReadable: getFormBoolValue(inputFormData,"isLastNameNotReadable"),
        houseNo: getFormStringValue(inputFormData,"houseNo"),
        isHouseNoNotReadable: getFormBoolValue(inputFormData,"isHouseNoNotReadable"),
        streetName: getFormStringValue(inputFormData,"streetName"),
        isStreetNameNotReadable: getFormBoolValue(inputFormData,"isStreetNameNotReadable"),
        apt: inputFormData["apt"], 
        isAptNotReadable: getFormBoolValue(inputFormData,"isAptNotReadable"),
        city: getFormStringValue(inputFormData,"city"),
        isCityNotReadable: getFormBoolValue(inputFormData,"isCityNotReadable"),
        state: getFormStringValue(inputFormData,"state"),
        isStateNotReadable: getFormBoolValue(inputFormData,"isStateNotReadable"),
        zipCode: getFormStringValue(inputFormData,"zipCode"),
        isZipCodeNotReadable: getFormBoolValue(inputFormData,"isZipCodeNotReadable"),
        email: getFormStringValue(inputFormData,"email"),
        isEmailNotReadable: getFormBoolValue(inputFormData,"isEmailNotReadable"),
        phone: inputFormData["phone"],
        isPhoneNotReadable: getFormBoolValue(inputFormData,"isPhoneNotReadable"),
        phoneExt: inputFormData["phoneExt"],
        isPhoneExtNotReadable: getFormBoolValue(inputFormData,"isPhoneExtNotReadable"),
        poBox: getFormStringValue(inputFormData,"poBox"),
        isPoBoxNotReadable: getFormBoolValue(inputFormData,"isPoBoxNotReadable")
    }

    const exemptionRequest: ECForm$ExemptionRequest = {
        renewIndicator: getFormStringValue(inputFormData,"renewIndicator"),
        renewUnitIndicator: getFormStringValue(inputFormData,"renewUnitIndicator"),
        newExemptionIndicator: getFormStringValue(inputFormData,"newExemptionIndicator"),
        exemptionCode1: getFormStringValue(inputFormData,"exemptionCode1"),
        isExemptionCode1NotReadable: getFormBoolValue(inputFormData,"isExemptionCode1NotReadable"),
        unitAddr1: getFormStringValue(inputFormData,"unitAddr1"),
        isUnitAddr1NotReadable: getFormBoolValue(inputFormData,"isUnitAddr1NotReadable"),
        houseId1: getFormStringValue(inputFormData,"houseId1"),
        isHouseId1NotReadable: getFormBoolValue(inputFormData,"isHouseId1NotReadable"),
        streetName1: getFormStringValue(inputFormData,"streetName1"),
        isStreetName1NotReadable: getFormBoolValue(inputFormData,"isStreetName1NotReadable"),
        unitId1: getFormStringValue(inputFormData,"unitId1"),
        isUnitId1NotReadable: getFormBoolValue(inputFormData,"isUnitId1NotReadable"),
        exemptionCode2: getFormStringValue(inputFormData,"exemptionCode2"),
        isExemptionCode2NotReadable: getFormBoolValue(inputFormData,"isExemptionCode2NotReadable"),
        unitAddr2: getFormStringValue(inputFormData,"unitAddr2"),
        isUnitAddr2NotReadable: getFormBoolValue(inputFormData,"isUnitAddr2NotReadable"),
        houseId2: getFormStringValue(inputFormData,"houseId2"),
        isHouseId2NotReadable: getFormBoolValue(inputFormData,"isHouseId2NotReadable"),
        streetName2: getFormStringValue(inputFormData,"streetName2"),
        isStreetName2NotReadable: getFormBoolValue(inputFormData,"isStreetName2NotReadable"),
        unitId2: getFormStringValue(inputFormData,"unitId2"),
        isUnitId2NotReadable: getFormBoolValue(inputFormData,"isUnitId2NotReadable"),
        exemptionCode3: getFormStringValue(inputFormData,"exemptionCode3"),
        isExemptionCode3NotReadable: getFormBoolValue(inputFormData,"isExemptionCode3NotReadable"),
        houseId3: getFormStringValue(inputFormData,"houseId3"),
        isHouseId3NotReadable: getFormBoolValue(inputFormData,"isHouseId3NotReadable"),
        streetName3: getFormStringValue(inputFormData,"streetName3"),
        isStreetName3NotReadable: getFormBoolValue(inputFormData,"isStreetName3NotReadable"),
        unitId3: getFormStringValue(inputFormData,"unitId3"),
        isUnitId3NotReadable: getFormBoolValue(inputFormData,"isUnitId3NotReadable")
    }

    const propertyInfo: Form$PropertyInfo = {
        apn: inputFormData["apn"],
        statementNo: inputFormData["statementNo"],
        isApnNotFound: getFormBoolValue(inputFormData,"isApnNotFound"),
        isStatementNotFound: getFormBoolValue(inputFormData,"isStatementNotFound")
    }

    const ecFormData: ECForm$Type = {
        propertyInfo: propertyInfo,
        billingContact: billingContact,
        exemptionRequest: exemptionRequest,
        signature: getSignatureInfo(inputFormData)
    }

    return ecFormData
}

const getRRFormData=(inputFormData: any)=>{
    const propertyInfo: Form$PropertyInfo = {
        apn: inputFormData["apn"],
        statementNo:  inputFormData["statementNo"],
        isApnNotFound: getFormBoolValue(inputFormData,"isApnNotFound"),
        isStatementNotFound: getFormBoolValue(inputFormData,"isStatementNotFound")
    }

    const rrFormData: RRForm$Type = {
        propertyInfo: propertyInfo,
        emergencyContactInfo: getEmergencyContactInfo(inputFormData),
        registrantInfo: getRegistrantInfo(inputFormData)
    }

    return rrFormData
}

const getRRBFormData=(inputFormData: any)=>{
    const propertyInfo: Form$PropertyInfo = {
        apn: inputFormData["apn"],
        isApnNotFound: getFormBoolValue(inputFormData,"isApnNotFound"),
        propHouseNumber: getFormStringValue(inputFormData,"propHouseNumber"),
        isPropHouseNumberNotReadable: getFormBoolValue(inputFormData,"isPropHouseNumberNotReadable"), 
        propStreetName:  getFormStringValue(inputFormData,"propStreetName"),
        isPropStreetNameNotReadable: getFormBoolValue(inputFormData,"isPropStreetNameNotReadable"),
        propCity: getFormStringValue(inputFormData,"propCity"),
        isPropCityNotReadable: getFormBoolValue(inputFormData,"isPropCityNotReadable"),
        propState: getFormStringValue(inputFormData,"propState"),
        isPropStateNotReadable: getFormBoolValue(inputFormData,"isPropStateNotReadable"),
        propZipCode: getFormStringValue(inputFormData,"propZipCode")
    }

    const rrbFormData: RRForm$Type = {
        propertyInfo: propertyInfo,
        emergencyContactInfo: getEmergencyContactInfo(inputFormData),
        registrantInfo: getRegistrantInfo(inputFormData)
    }

    return rrbFormData
}

const getEmergencyContactInfo=(inputFormData:any)=>{
    const emergencyContactInfo: RRForm$EmergencyContactInfo = {
        emergencyFirstName: getFormStringValue(inputFormData,"emergencyFirstName"),
        isEmergencyFirstNameNotReadable: getFormBoolValue(inputFormData,"isEmergencyFirstNameNotReadable"),
        emergencyLastName: getFormStringValue(inputFormData,"emergencyLastName"),
        isEmergencyLastNameNotReadable: getFormBoolValue(inputFormData,"isEmergencyLastNameNotReadable"),
        emergencyHouseNumber: getFormStringValue(inputFormData,"emergencyHouseNumber"),
        isEmergencyHouseNumberNotReadable: getFormBoolValue(inputFormData,"isEmergencyHouseNumberNotReadable"),
        emergencyStreetName: getFormStringValue(inputFormData,"emergencyStreetName"),
        isEmergencyStreetNameNotReadable: getFormBoolValue(inputFormData,"isEmergencyStreetNameNotReadable"),
        emergencyCity: getFormStringValue(inputFormData,"emergencyCity"),
        isEmergencyCityNotReadable: getFormBoolValue(inputFormData,"isEmergencyCityNotReadable"),
        emergencyState: getFormStringValue(inputFormData,"emergencyState"),
        isEmergencyStateNotReadable: getFormBoolValue(inputFormData,"isEmergencyStateNotReadable"),
        emergencyZipCode: getFormStringValue(inputFormData,"emergencyZipCode"),
        isEmergencyZipCodeNotReadable: getFormBoolValue(inputFormData,"isEmergencyZipCodeNotReadable"),
        emergencyPhone: inputFormData["emergencyPhone"],
        isEmergencyPhoneNotReadable: getFormBoolValue(inputFormData,"isEmergencyPhoneNotReadable"),
        emergencyEmail: getFormStringValue(inputFormData,"emergencyEmail"),
        isEmergencyEmailNotReadable: getFormBoolValue(inputFormData,"isEmergencyEmailNotReadable"),
        totalUnitsPrinted: getFormStringValue(inputFormData,"totalUnitsPrinted"),
        isTotalUnitsPrintedNotReadable: getFormBoolValue(inputFormData,"isTotalUnitsPrintedNotReadable"),
        totalUnitsEntered: inputFormData["totalUnitsEntered"],
        isTotalUnitsEnteredNotReadable: getFormBoolValue(inputFormData,"isTotalUnitsEnteredNotReadable")
    }

    return emergencyContactInfo
}

const getRegistrantInfo=(inputFormData:any)=> {
    const registrantInfo: RRForm$RegistrantInfo = {
        sameInfoCheck: getFormStringValue(inputFormData,"sameInfoCheck"),
        registrantFirstName:  getFormStringValue(inputFormData,"registrantFirstName"),
        isRegistrantFirstNameNotReadable: getFormBoolValue(inputFormData,"isRegistrantFirstNameNotReadable"),
        registrantLastName: getFormStringValue(inputFormData,"registrantLastName"),
        isRegistrantLastNameNotReadable: getFormBoolValue(inputFormData,"isRegistrantLastNameNotReadable"),
        registrantPhone: inputFormData["registrantPhone"],
        isRegistrantPhoneNotReadable: getFormBoolValue(inputFormData,"isRegistrantPhoneNotReadable"),
        registrantEmail:  getFormStringValue(inputFormData,"registrantEmail"),
        isRegistrantEmailNotReadable: getFormBoolValue(inputFormData,"isRegistrantEmailNotReadable")
    }

    return registrantInfo
} 

const getSignatureInfo=(inputFormData: any)=> {
    const signatureInfo:Form$SignatureInfo = {
        printedName: getFormStringValue(inputFormData,'printedName'),
        isPrintNameNotReadable: getFormBoolValue(inputFormData,'isPrintNameNotReadable'),
        signatureIndicator: getFormStringValue(inputFormData,'signatureIndicator'),
        signatureDate: getFormStringValue(inputFormData,'signatureDate'),
        isSignatureDateNotReadable: getFormBoolValue(inputFormData,'isSignatureDateNotReadable')
    }

    return signatureInfo
}

const getRRUFormData=(inputFormData: any)=>{
    const propertyInfo: Form$PropertyInfo = {
        apn: inputFormData["apn"],
        isStatementNotFound: getFormBoolValue(inputFormData,"isStatementNotFound")
    }

    const formPageInfo: RRUForm$FormPageInfo = {
        formPageNumber: inputFormData["formPageNumber"],
        formPageTotal: inputFormData["formPageTotal"]
    }

    const rruFormData: RRUForm$Type = {
        propertyInfo: propertyInfo,
        unitInfo1: getUnitInfo(1,inputFormData),
        unitInfo2: getUnitInfo(2,inputFormData),
        unitInfo3: getUnitInfo(3,inputFormData),
        unitInfo4: getUnitInfo(4,inputFormData),
        unitInfo5: getUnitInfo(5,inputFormData),
        signature: getSignatureInfo(inputFormData),
        formPageInfo: formPageInfo
    }

    return rruFormData
}

export const getUnitFieldName=(formIndex:number,suffixFieldName:string)=>{
    const fieldName=`unit${formIndex}${suffixFieldName}`
    return fieldName
}

export const getBoolUnitFieldName=(formIndex:number, suffixFieldName:string)=>{
    const fieldName=`isUnit${formIndex}${suffixFieldName}NotReadable`
    return fieldName
}

export const SuffixHouseNumber = "HouseNumber"
export const SuffixStreetName = "StreetName"
export const SuffixUnitNumber = "UnitNumber"
export const SuffixBedroomCount = "BedroomCount"
export const SuffixMoveinDate = "MoveinDate"
export const SuffixMoveinDateCheck = "MoveinDateCheck"
export const SuffixCurrentRent = "CurrentRent"
export const SuffixLastIncreaseDate = "LastIncreaseDate"
export const SuffixLastIncreaseDateCheck = "LastIncreaseDateCheck"
export const SuffixUtilityPaidByLandlord = "UtilityPaidByLandlord"
export const SuffixIncludeParking = "IncludeParking"
export const SuffixExemptionType = "ExemptionType"
export const SuffixTempVacantCheck = "TempVacantCheck"

const getUnitInfo=(formIndex:number,inputFormData:any)=>{
    const fieldHouseNumber=getUnitFieldName(formIndex,SuffixHouseNumber)
    const fieldBoolHouseNumber=getBoolUnitFieldName(formIndex,SuffixHouseNumber)
    const fieldStreetName=getUnitFieldName(formIndex,SuffixStreetName)
    const fieldBoolStreetName=getBoolUnitFieldName(formIndex,SuffixStreetName)
    const fieldUnitNumber=getUnitFieldName(formIndex,SuffixUnitNumber)
    const fieldBoolUnitNumber=getBoolUnitFieldName(formIndex,SuffixUnitNumber)
    const fieldBedroomCount=getUnitFieldName(formIndex,SuffixBedroomCount)
    const fieldBoolBedroomCount=getBoolUnitFieldName(formIndex,SuffixBedroomCount)
    const fieldMoveinDate=getUnitFieldName(formIndex,SuffixMoveinDate)
    const fieldBoolMoveinDate=getBoolUnitFieldName(formIndex,SuffixMoveinDate)
    const fieldMoveinDateCheck=getUnitFieldName(formIndex,SuffixMoveinDateCheck)
    const fieldCurrentRent=getUnitFieldName(formIndex,SuffixCurrentRent)
    const fieldBoolCurrentRent=getBoolUnitFieldName(formIndex,SuffixCurrentRent)
    const fieldLastIncreaseDate=getUnitFieldName(formIndex,SuffixLastIncreaseDate)
    const fieldBoolLastIncreaseDate=getBoolUnitFieldName(formIndex,SuffixLastIncreaseDate)
    const fieldLastIncreaseDateCheck=getUnitFieldName(formIndex,SuffixLastIncreaseDateCheck)
    const fieldUtilityPaidByLandlord=getUnitFieldName(formIndex,SuffixUtilityPaidByLandlord)
    const fieldIncludeParking=getUnitFieldName(formIndex,SuffixIncludeParking)
    const fieldExemptionType=getUnitFieldName(formIndex,SuffixExemptionType)
    const fieldTempVacantCheck=getUnitFieldName(formIndex,SuffixTempVacantCheck)

    let unitInfo:any = {}
    unitInfo[fieldHouseNumber]=getFormStringValue(inputFormData,fieldHouseNumber)
    unitInfo[fieldBoolHouseNumber]=getFormBoolValue(inputFormData,fieldBoolHouseNumber)    
    unitInfo[fieldStreetName]=getFormStringValue(inputFormData,fieldStreetName)
    unitInfo[fieldBoolStreetName]=getFormBoolValue(inputFormData,fieldBoolStreetName)
    unitInfo[fieldUnitNumber]=getFormStringValue(inputFormData,fieldUnitNumber)
    unitInfo[fieldBoolUnitNumber]=getFormBoolValue(inputFormData,fieldBoolUnitNumber)
    unitInfo[fieldBedroomCount]=inputFormData[fieldBedroomCount]
    unitInfo[fieldBoolBedroomCount]=getFormBoolValue(inputFormData,fieldBoolBedroomCount)
    unitInfo[fieldMoveinDate]=getFormStringValue(inputFormData,fieldMoveinDate)
    unitInfo[fieldBoolMoveinDate]=getFormBoolValue(inputFormData,fieldBoolMoveinDate)
    unitInfo[fieldMoveinDateCheck]=getFormStringValue(inputFormData,fieldMoveinDateCheck)
    unitInfo[fieldCurrentRent]=inputFormData[fieldCurrentRent]
    unitInfo[fieldBoolCurrentRent]=getFormBoolValue(inputFormData,fieldBoolCurrentRent)
    unitInfo[fieldLastIncreaseDate]=getFormStringValue(inputFormData,fieldLastIncreaseDate)
    unitInfo[fieldBoolLastIncreaseDate]=getFormBoolValue(inputFormData,fieldBoolLastIncreaseDate)
    unitInfo[fieldLastIncreaseDateCheck]=getFormStringValue(inputFormData,fieldLastIncreaseDateCheck)
    unitInfo[fieldUtilityPaidByLandlord]=getFormStringValue(inputFormData,fieldUtilityPaidByLandlord)
    unitInfo[fieldIncludeParking]=getFormStringValue(inputFormData,fieldIncludeParking)
    unitInfo[fieldExemptionType]=getFormStringValue(inputFormData,fieldExemptionType)
    unitInfo[fieldTempVacantCheck]=getFormStringValue(inputFormData,fieldTempVacantCheck)

    return unitInfo
}


// WEBPACK FOOTER //
// ./src/redux/kratos/submitFormData.js